import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  innerContainerStyle: {
    maxWidth: '100%',
  },
  accentBanner: {
    maxHeight: 160,
  },
  content: {
    marginHorizontal: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  imagesContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 16,
    flexWrap: 'wrap',
  },
  hintButton: {
    marginTop: 60,
  },
});
